<div class="help-question">
    <div class="help-question-icon">
        <img src="/assets/images/question.svg" alt="No Icon" />
    </div>
    <div class="help-question-message" [class.left-direction]="leftDirection" *ngIf="text">
        <div>{{ text | translate }}</div>
    </div>
</div>